// config.demo.js
//
// Centre DEMO (matricula.dieres.com): entorn de demostració del
// funcionament de la plataforma, basat en la configuració real de cavall
// bernat però SENSE cap dada personal real (dump anonimitzat, veure
// inscripcions_api/scramble.php) i sense cap passarel·la de pagament activa.

const config =
{
    cid: 'demo',

    // llistat dels camps d'autorització del pas "Protecció de dades" d'aquest centre
    // (veure src/components/enrolmentform/authorizations/demo/)
    autoritzacions: [
        'authAlcohol', 'authAMPA', 'authCompromis', 'authDretsImatge', 'authGDPR',
        'authLlibresSocialitzats', 'authMedica', 'authMobils', 'authPagament',
        'authPortatils', 'authResponsable', 'authSortides',
    ],

    phone: "645621660",
    email: "info@dieres.com",

    headerLogo:  'img/logo_bn_demo.png',
    headerTitle:  'Centre DEMO',
    headerURL: 'https://matricula.dieres.com/',

    enrollmentPostURL: '/post/',
    apiURL: '/api/',

    popupInicial: false,

    adjuntarArxiusNoObligatori: false,

    // llibre de família (plana progenitors + plana alumne) obligatori per als menors d'edat
    llibreFamiliaObligatori: false,

    validaIDdocuments: false,
    tipusDocTSI: true,

    fotoCarnet: true,
    validaIAfotoCarnetFile: false,
    validaIAiddocumentFrontFile: false,

    telefonObligatori: true,
    carnetFamiliaNombrosa: false,

    contacteEmergenciaObligatori: true,

    adjuntMedic: true,
    adjuntMedicObligatori: false,

    datesNoBloquejenInscripcio: false,

    noPreguntarSiEsNouAlumne: false,

    notesAcces: false,

    mostraTorns: false,

    demanaConvalidacions: false,

    logo: 'img/logo_demo.jpg',
    titol: 'DEMO',

    favicon: '/img/favicon-demo.ico',
    faviconGestio: '/gestio/img/favicon-demo.ico',

    assignatures: 'assignatures/assignatures.demo.json',
    families: 'families/families.demo.json',
    dadesbancaries: 'dadesbancaries/dadesbancaries.demo.json',
    calculquota: 'quotes.demo.json',

    treballantFile: true,
    necessitatsEducativesEspecials: true,

    repetidor: false,
    repetidorsNoPodenAgafarAssignaturesDe2n: false,

    textDadesMediquesAlgunSi: "",

    textBotoMatricular: "INSCRIURE",

    proporcionarPreinscripcioNous: true,
    proporcionarTitolPreinscripcioNous: true,

    textAlumneNouAlCentre: "Ets alumne nou als estudis que et matricules?",
    textAlumneNouAlCentreSub: null,

    // sense passarel·la de pagament real: entorn purament de demostració
    urlTPV: "https://matricula.dieres.com/tpv/",
    pagamentTPV: true,
    pagamentTransferencia: false,

    textInscripcioText: null,

    dosTerminisDefault: false, 
    dosTerminisAmagaBoto: false, // no cal ni mostrar botó

    textTerminis: [ "(amb la matrícula)", "(del 14 al 30 de setembre)", null ], // els que tenen tres terminis ja especifiquem expressament

    // a diferència dels centres reals, aquí NO restringim per mes: el demo ha de
    // poder mostrar l'opció de dos terminis sempre, independentment de la data
    dosTerminisEnabled: true,
    dosTerminisEnabledFalseCondicio: 0,

    sexeNoBinari: true,

    pattern_batx_nocturn: /^BATXLOE\d{5}N[A-Z]{1,2}$/,
    pattern_1r_batx: /^BATXLOE\d{4}1[^N][A-Z]{1,2}$/,
    pattern_2n_batx: /^BATXLOE\d{4}2[^N][A-Z]{1,2}$/,

    // documents de prova ja reconeguts per la resta del codi (veure
    // inscripcions_api/index.php i inscripcions_api/scramble.php)
    su: ['WyIxMTExMTEx', 'MUgiLCIyMjIyMjIyM', 'koiLCI0NTQ5MjQwNVMiXQ=='],
};

export default config;
